{
    "apiSuffix": "api",
    "agent_commission_get_published_version": "agentcommission/divisions/{divisionId}/{scopeId}/published-versions",
    "agent_commission_get_latest": "agentcommission/divisions/{divisionId}/{scopeId}/latest",
    "agent_commission_get_rates": "agentcommission/divisions/{divisionId}/{scopeId}/rates",
    "agent_commission_find_rate": "agentcommission/divisions/{divisionId}/find-rate",

    "discounts_get_by_id": "discounts/{id}",
    "discounts_get_by_type": "discounts",
    "discounts_get_list": "discounts/list",
    "discounts_save_by_id": "discounts/{id}",
    "discounts_save": "discounts",

    "agents_search": "agents/search",
    "agents_search_by_type": "Agents/Search-by-type",
    "agents_get_offices_by_id": "Agents/offices-by-id",
    
    "reference_data_get_countries": "referencedata/countries",
    "region_get_all": "Region/{divisionId}/get-all",
    "region_create": "Region/create",
    "region_update": "Region/update",
    "region_get_countries_by_division": "Region/{divisionId}/get-countries-by-division",
    "region_create_regions_for_countries": "Region/create-regions-for-countries",
    "region_get_inheritance": "Region/{divisionId}/inheritance",
    "region_set_inheritance": "Region/{divisionId}/inheritance",
    "reference_data_get_currencies": "referencedata/currencies",
    "reference_data_get_booking_systems": "referencedata/booking-systems",
    "reference_data_get_report_text": "referencedata/report-text",
    "reference_data_get_course_languages": "CourseLanguages",
    "reference_data_course_language_by_id": "CourseLanguages/{languageId}",
    "course_languages_save": "CourseLanguages/save",
    "reference_data_get_course_intensity": "referencedata/course-intensity",
    "course_intensities_get_with_overrides": "CourseIntensities/course-intensity-with-overrides",
    "course_intensities_save_school_override": "CourseIntensities/course-intensity-school-override",
    "course_intensities_create": "CourseIntensities/course-intensity",
    "reference_data_get_bathroom_types": "referencedata/bathroom-types",
    "reference_data_get_room_types": "referencedata/room-types",
    "reference_data_get_room_grades": "referencedata/room-grades",
    "reference_data_get_board_basis": "referencedata/board-basis",  
    "reference_data_get_accommodation_types": "referencedata/accommodation-types",
    "reference_data_get_unit_types": "referencedata/unit-types",
    "reference_data_get_transfer_types": "referencedata/transfer-types",
    "reference_data_get_transfer_ports": "referencedata/transfer-ports",
    "reference_data_get_addon_types": "referencedata/addon-types",
    "reference_data_product_category": "referencedata/product-category",
    "reference_data_product_category_by_id": "referencedata/product-category/{categoryId}",
    "reference_data_account_category": "referencedata/account-category",
    "reference_data_account_category_by_id": "referencedata/account-category/{categoryId}",

    "get_product_divisions": "Divisions",
    "get_product_division_by_id" : "Divisions/{divisionId}",
    "save_product_division": "Divisions/create",
    
    "fees_get_fees": "fees/{divisionId}/get-all",
    "fees_get_fee_by_id": "fees/{divisionId}/get-by-id/{id}",
    "fees_save": "fees/{divisionId}/save",
    "cancellationfees_get_all": "CancellationFee/{divisionId}/get-all",
    "cancellationfees_get_by_id": "CancellationFee/{divisionId}/get-by-id/{cancellationFeeId}",
    "cancellationfees_save": "CancellationFee/{divisionId}/save",
    "cancellationfees_delete": "CancellationFee/division/{divisionId}/cancellationFee/{cancellationFeeId}",
    "fee_offering_create": "FeeOffering",
    "fee_offering_update": "FeeOffering/{id}",

    "products_get_offerings_by_school": "products/offerings-by-school",
    "products_get_all": "products",
    "products_lookup": "Products/lookup",
    "products_names": "products/names",

    "school_dates_get_all": "schooldates",

    "schools_get_all": "schools",
    "schools_save": "schools",
    "schools_get_by_id": "schools/{id}",
    "schools_get_by_centre":  "Schools/centre/{centreId}",
    "schools_create":  "Schools/create",

    "centres_get_all": "centres",
    "centres_get_all_in_details" : "centres/get-all-in-details",
    "get_centre": "Centres/{id}",
    "centre_save": "Centres",
    "centre_update": "Centres/{id}",

    "accommodation_get_by_id": "accommodation/get-by-id/{accommodationId}",
    "accommodation_get_all": "accommodation/get-all",
    "accommodation_get_all_with_division": "accommodation/get-all/{divisionId}",
    "accommodation_save": "accommodation/save",

    "accommodation_room_get_by_id": "accommodationrooms/{divisionId}/get-by-id/{accommodationRoomId}",
    "accommodation_room_get_all_by_division": "accommodationrooms/{divisionId}/get-all",
    "accommodation_room_get_all": "accommodationrooms/{divisionId}/get-all/{accommodationId}",
    "accommodation_room_save": "accommodationrooms/{divisionId}/save",

    "addons_get_by_id": "addons/{divisionId}/get-by-id/{addonId}",
    "addons_get_all": "addons/{divisionId}/get-all",
    "addons_save": "addons/{divisionId}/save",
    
    "booking_system_exclusion_get_products": "BookingSystemExclusion/products",
    "booking_system_exclusion_get_divisions": "BookingSystemExclusion/divisions",
    "booking_system_exclusion_get_schools": "BookingSystemExclusion/schools",
    "booking_system_exclusion_update": "BookingSystemExclusion/booking-system/{bookingSystemId}/product/{productTypeId}/{productId}",
    "booking_system_exclusion_update_division": "BookingSystemExclusion/booking-system/{bookingSystemId}/division/{divisionId}",
    "booking_system_exclusion_update_school": "BookingSystemExclusion/booking-system/{bookingSystemId}/school/{schoolId}",
    "booking_system_exclusion_update_school_bulk": "BookingSystemExclusion/school/exclude",
    "booking_system_exclusion_get_product_offering": "BookingSystemExclusion/schools/{schoolId}/product-offerings/{productTypeId}/{productId}",
    "booking_system_exclusion_set_product_offering": "BookingSystemExclusion/schools/{schoolId}/product-offerings/{productTypeId}/{productId}",

    "courses_get_by_id": "courses/{divisionId}/get-by-id/{courseId}",
    "courses_get_all": "courses/{divisionId}/get-all/",
    "courses_save": "courses/{divisionId}/save",

    "transfers_get_by_id": "transfers/{divisionId}/get-by-id/{transferId}",
    "transfers_get_all": "transfers/{divisionId}/get-all",
    "transfers_save": "transfers/{divisionId}/save",    
    "packages_get_by_id": "Package/{packageId}",
    "packages_get_all": "Package",
    "packages_save": "Package",
    "packages_update":"Package/{packageId}",
    
    "package_offering_get_all": "PackageOffering",
    "package_offering_get_by_id": "PackageOffering/{packageOfferingId}",
    "package_offering_get_by_school": "PackageOffering/school/{schoolId}",
    "package_offering_save": "PackageOffering",

    "edit_product_offerings_get_all_active": "Offerings/{divisionId}/get-all-active",
    "edit_product_offerings_create": "Offerings/{divisionId}/create/{pricingYear}",
    "edit_product_offerings_update_active": "Offerings/{divisionId}/update/{pricingYear}",
    "edit_product_offerings_update_active_dates": "Offerings/{divisionId}/date-strategy",
    "edit_product_offerings_delete_date_strategy": "Offerings/{divisionId}/date-strategy",
    "edit_product_offerings_recommission": "Offerings/{divisionId}/activate",
    "edit_product_offerings_decommission": "Offerings/{divisionId}/deactivate",
    "edit_product_offerings_delete": "Offerings/{divisionId}/deactivate",
    "edit_product_offerings_undelete": "Offerings/{divisionId}/activate",
    "edit_product_offerings_exclude": "Offerings/exclude",

    "pricing_years_get_all": "pricingyears/{divisionId}",
    "pricing_years_get_by_division": "PricingYears/{divisionId}",
    "pricing_years_create": "PricingYears/{divisionId}/create/{year}",
    "pricing_years_validate_academic_year_dates_draft": "PricingYears/{divisionId}/validate-academic-year-dates-draft",
    "pricing_years_initiate_draft": "PricingYears/{divisionId}/initiate-draft",
    "pricing_years_load_draft": "PricingYears/{divisionId}/load-draft",
    "pricing_years_update_draft": "PricingYears/{divisionId}/update-draft",
    "pricing_years_save_draft": "PricingYears/{divisionId}/save-draft",
    "pricing_years_validate_draft": "PricingYears/{divisionId}/validate-draft",
    "pricing_years_fully_validate_draft": "PricingYears/{divisionId}/fully-validate-draft",
    "pricing_years_publish_draft": "PricingYears/{divisionId}/publish-draft",
    "pricing_years_minimum_start_dates": "PricingYears/{divisionId}/minimum-start-dates/{year}",

    "user_get_user": "user",

    "get_ports_with_terminals": "TransferPorts/get-ports-with-terminals",
    "post_ports_with_terminals": "TransferPorts/save-port-with-terminals",
    "holiday_manager_get": "HolidayManager/{divisionId}/holidays",
    "holiday_manager_save": "HolidayManager/{divisionId}/holidays/save",
    "holiday_manager_copy": "HolidayManager/{divisionId}/holidays/copy",
    "holiday_get": "Holiday/pricingYear/{year}",
    "holiday_create": "Holiday/pricingYear/{year}/create",
    "holiday_delete": "Holiday/pricingYear/{year}/delete",
    "holiday_copy": "Holiday/copy",

    "commission_group_get_all": "CommissionGroup/{divisionId}/get-all",
    "commission_group_get_by_id": "CommissionGroup/{divisionId}",
    "commission_group_create": "CommissionGroup/{divisionId}",
    "commission_group_update": "CommissionGroup/{divisionId}",

    "early_bird_offer_get_all": "EarlyBirdOffer/division/{divisionId}",
    "early_bird_offer_get": "EarlyBirdOffer/division/{divisionId}/year/{year}",
    "early_bird_offer_upsert": "EarlyBirdOffer/division/{divisionId}/year/{year}",
    "early_bird_offer_delete": "EarlyBirdOffer/division/{divisionId}/year/{year}",

    "tax_rules_get_all": "tax-rules",
    "tax_rules_get_by_id": "tax-rules/{id}",
    "tax_rules_tax_code_is_unique": "tax-rules/tax-codes/{taxCode}/is-unique",
    "tax_rules_put": "tax-rules/{id}"
}
